import { useThree } from "@react-three/fiber";
import { useEffect } from "react";
import * as THREE from "three";

const worldPosition = new THREE.Vector3();
const worldQuaternion = new THREE.Quaternion();

export function InitialBakedCameraPose({
  cameraObject,
  enabled,
  onApplied,
}: {
  cameraObject: THREE.Camera | null;
  enabled: boolean;
  onApplied?: () => void;
}) {
  const { camera } = useThree();

  useEffect(() => {
    if (!enabled || !cameraObject) return;

    cameraObject.updateMatrixWorld(true);
    cameraObject.getWorldPosition(worldPosition);
    cameraObject.getWorldQuaternion(worldQuaternion);

    camera.position.copy(worldPosition);
    camera.quaternion.copy(worldQuaternion);
    camera.updateProjectionMatrix();

    onApplied?.();
  }, [camera, cameraObject, enabled, onApplied]);

  return null;
}
